import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ForbiddenError } from "@/lib/api-client";
import { sessionHasPermission, sessionQueryKey } from "@/queries/session";
import type { AdminSession } from "@/queries/session";
import { tenantRecordOptions } from "@/features/tenants/queries";
import { TenantRecordLayout } from "@/features/tenants/pages/tenant-record-page";

export const Route = createFileRoute("/_authed/tenant-records/$slug")({
  beforeLoad: async ({ context, params }) => {
    const session = context.queryClient.getQueryData<AdminSession>(sessionQueryKey);
    if (!session?.is_platform_admin || !sessionHasPermission(session, "tenants.read")) {
      throw new ForbiddenError(null, null, "Platform tenant records are unavailable to this account.");
    }
    const record = await context.queryClient.fetchQuery(tenantRecordOptions(params.slug));
    return { record };
  },
  component: () => <TenantRecordLayout><Outlet /></TenantRecordLayout>,
});
